// extracted by mini-css-extract-plugin
module.exports = {"fixateMenuButton":"FixateMenuButton_fixateMenuButton__1Z2mQ"};